module.exports = __webpack_public_path__ + "img/737da25.jpg";